/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enter_EmailInputs */

const en_enter_email = /** @type {(inputs: Enter_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email`)
};

const nl_enter_email = /** @type {(inputs: Enter_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer je e-mailadres in`)
};

/**
* | output |
* | --- |
* | "Enter your email" |
*
* @param {Enter_EmailInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const enter_email = /** @type {((inputs?: Enter_EmailInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enter_EmailInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_enter_email(inputs)
	return en_enter_email(inputs)
});